module.exports = "<app-my-calls-today></app-my-calls-today>\r\n"